import styled from 'styled-components';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid, GridItem } from '../Grid';

export const ImageGalleryGrid = styled(Grid)`
  margin-top: ${spacing(8)};
`;

export const DesktopOnlyGridItem = styled(GridItem)`
  display: none;
  ${mediaQuery.tabletLandscape`
    display: block;
  `}
`;

export const TabletOnlyGridItem = styled(GridItem)`
  display: none;
  ${mediaQuery.tabletPortrait`
    display: block;
  `}
  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;

export const MobileGridItem = styled(GridItem)`
  display: flex;
  flex-wrap: nowrap;
`;

export const MobileScrollableWrapper = styled.div`
  display: flex;
  ${mediaQuery.tabletPortrait`
    display: none;
  `}
  margin-left: -${spacing(1)};
  margin-right: -${spacing(1)};
  flex-wrap: nowrap;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
